/**
 * 页内锚点常量
 *
 * 需求 §4.4.2：左侧 Tab 为四大模块
 *
 * ⚠️ ANCHORS 仅维护锚点 key 列表（单一数据源），
 *    标题文案从各子组件导出常量获取，避免双重维护。
 *    DOM id 与 key 一致，使用命名常量避免改 key 忘记同步 id。
 */
import { TAnchor } from '../types/common';

export const A_OVERVIEW: TAnchor = 'OVERVIEW';
export const A_TREND: TAnchor = 'TREND';
export const A_CHANNEL: TAnchor = 'CHANNEL';
export const A_COUNTRY: TAnchor = 'COUNTRY';

/** 锚点列表（顺序决定导航顺序和默认激活项） */
export const ANCHORS: TAnchor[] = [A_OVERVIEW, A_TREND, A_CHANNEL, A_COUNTRY];
